import React from 'react';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';

const PropertySettlement = () => {
  return (
    <div className='servicePage'>
      <div className='servicePageContent'>
        <div className="header">Property Settlement</div>
        <div className="body">
          <ServiceDescriptionSection
            content={
              <div>
                <div>Property settlement involves dividing the assets and liabilities of a couple after separation or divorce. Key aspects include:</div>
                <ul>
                  <li><strong>Asset Identification:</strong> Both parties must disclose their assets, liabilities, and financial resources. This includes property, bank accounts, superannuation, and debts.</li>
                  <li><strong>Valuation:</strong> Assets are assessed to determine their current market value. This may involve independent valuations, particularly for real estate or business interests.</li>
                  <li>
                    <strong>Division of Property:</strong> Assets are assessed to determine their current market value. This may involve independent valuations, particularly for real estate or business interests.
                    <ul>
                      <li>The financial and non-financial contributions of each party (e.g., income, homemaking).</li>
                      <li>The future needs of both parties (e.g., age, health, and financial resources).</li>
                    </ul>
                  </li>
                  <li><strong>Consent Orders:</strong> If both parties agree on the property settlement, they can apply for Consent Orders through the Family Court, which makes the agreement legally binding.</li>
                  <li><strong>Time Limits:</strong> There are time limits for initiating property settlement proceedings—typically within 12 months from the date of divorce for married couples and two years for de facto couples.</li>
                </ul>
              </div>
            }
          />
          <ServiceLegalRepresentationRationale
            header="Legal Representation in Family Law Matters"
            content="Navigating property settlement can be complex and emotionally challenging. Seeking legal advice is crucial to ensure that property is divided fairly and equally in ownership disputes."
          />
          <ServiceContactUsSection
            header="Contact Us for Legal Assistance"
            content="If you require legal assistance with property settlement, our dedicated team is here to help. We provide expert advice and representation tailored to your unique circumstances, ensuring the best possible outcome for you and your family."
          />
        </div>
      </div>
    </div>
  );
};

export default PropertySettlement;